import { getToken } from '../../utils/token/token'

// eslint-disable-next-line default-param-last
const getHeaders = (method = 'GET', body) => ({
  headers: new Headers({
    'Content-Type': 'application/json',
    Authorization: `DT-Fenix-Token ${getToken()}`,
  }),
  method,
  body: JSON.stringify(body),
})

const handleErrors = (response) => {
  if (response?.status >= 500) {
    const errorMessage = typeof response?.data === 'string' ? response?.data : 'Internal server error'
    throw new Error(errorMessage)
  }

  if (typeof response !== 'object') {
    throw new TypeError('response must be an object')
  }

  if (response?.status !== 'OK') {
    if (typeof response?.message === 'string') {
      throw new Error(response?.message)
    } else {
      throw new Error(response?.errors?.join('\n') ?? 'Ocorreu um erro inesperado')
    }
  }

  return response
}

export { getHeaders, handleErrors }
